module.exports = __webpack_public_path__ + "static/media/bg.20ff05f8.png";